import React from "react";
import { connect } from "react-redux";

import { withT } from "services/translation/";

import { Row, Col, Form, Button, Card, InputGroup } from "react-bootstrap";

import 'react-phone-number-input/style.css';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import { generateNumericalStringNotAllSame } from "utils/math";

import { getPathRootFromRoute } from "services/redux/selectors/app/";
import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";

import Loading from "components/Loading";
import { Tooltip } from "components/Common/Tooltip/";

import Alert from "components/Common/Alert";

import {
  requestUpdateKeyholderStart,
  requestUpdateKeyholderCancel,
  requestRemoveKeyholderStart,
  requestMoveKeyholderStart
} from "services/redux/actions";
import {
  requestUpdateSinglesitecontactStart,
  requestUpdateSinglesitecontactCancel,
  requestRemoveSinglesitecontactStart,
  requestMoveSinglesitecontactStart,
} from "services/redux/actions/singleSites";

import Icon from "components/Icons/Icon";

import { getLocalDateMoment } from "utils/date";

import "./Keyholders.scss";

class KeyholderCard extends React.Component {
  state = {
    editing: false,

    name: "",
    email: "",
    phone: "",
    job_title: "",
    password: false,
    passwordText: "",
    showPassword: false,
    passwordInputFocus: false,
    passwordEdited: false,
    showSmsOption: false,
    sendSms: true,
    invalidPhoneNumber: "",
    invalidPassword: "",
  };
  componentDidMount = () => {
    this.resetFields();
  };
  resetFields = () => {
    const { position, name, email, phone, job_title, password} = this.props;

    this.setState({
      position,
      name,
      email: email || "",
      phone: phone || "",
      job_title: job_title || "",
      password,
      passwordText: "",
      showPassword: false,
      passwordInputFocus: false,
      passwordEdited: false,
      showSmsOption: false,
      sendSms: true,
      invalidPhoneNumber: "",
      invalidPassword: "",
    });
  };
  updateKeyholder = () => {
    const { dispatch, origin, uuid, id, enterprise_site_id, sudo_site_id, position } = this.props;

    const { name, email, phone, job_title, password, passwordText, passwordEdited, showSmsOption, sendSms } = this.state;

    if (origin === "SingleSite") {
      const params = {
        id: id,
        sudo_site_id,
        position,
        name,
        email,
        phone,
        job_title,
      }
      if (passwordEdited) {
        params["password"] = passwordText;
      }
      if (showSmsOption && sendSms) {
        params["sms"] = "Y";
      }

      dispatch(
        requestUpdateSinglesitecontactStart({
          contact_id: id,
          sudo_site_id,
          params: params,
        })
      );

      this.setState({
        password: passwordEdited ? true : password,
        passwordText: "",
        showPassword: false,
        passwordInputFocus: false,
        passwordEdited: false,
        showSmsOption: false,
        sendSms: false,
        invalidPhoneNumber: "",
        invalidPassword: "",
      });

    } else {
      const params = {
        position,
        name,
        email,
        phone,
        job_title,
      }
      if (passwordEdited) {
        params["password"] = passwordText;
      }
      if (showSmsOption && sendSms) {
        params["sms"] = "Y";
      }

      dispatch(
        requestUpdateKeyholderStart({
          uuid,
          enterprise_site_id,
          params: params,
        })
      );

      this.setState({
        password: passwordEdited ? true : password,
        passwordText: "",
        showPassword: false,
        passwordInputFocus: false,
        passwordEdited: false,
        showSmsOption: false,
        sendSms: false,
        invalidPhoneNumber: "",
        invalidPassword: "",
      });
    };
  };
  removeKeyholder = () => {
    const { dispatch, origin, uuid, id, enterprise_site_id, sudo_site_id } = this.props;

    if (origin === "SingleSite") {
      dispatch(
        requestRemoveSinglesitecontactStart({
          contact_id: id,
          sudo_site_id,
          params: {
            id: id,
            sudo_site_id,
          },
        })
      );
    } else {
      dispatch(
        requestRemoveKeyholderStart({
          params: { uuid, enterprise_site_id }
        })
      );
    };
  };
  moveKeyholder = direction => {
    const { dispatch, origin, uuid, id, enterprise_site_id, sudo_site_id } = this.props;

    if (origin === "SingleSite") {
      dispatch(
        requestMoveSinglesitecontactStart({
          contact_id: id,
          sudo_site_id,
          direction: direction.toLowerCase(),
          params: {
            id: id,
            sudo_site_id,
          },
        })
      );
    } else {
      dispatch(
        requestMoveKeyholderStart({
          direction,
          params: { uuid, enterprise_site_id }
        })
      );
    };
  };
  componentDidUpdate = () => {
    const { origin, actions, dispatch } = this.props;

    if (actions.update.success && this.state.editing) {
      this.setState({ editing: false });
      // Reset success state
      if (origin === "SingleSite") {
        dispatch(requestUpdateSinglesitecontactCancel());
      } else {
        dispatch(requestUpdateKeyholderCancel());
      }
    }
  };
  render() {
    const {
      pathRoot,
      enterprise,
      site,
      actions,
      loading,

      keyholders,
      position,
      sms_sent,
      t
    } = this.props;

    const removing = actions.remove.loading === true;
    const moving = actions.move.loading === true;
    const updating = actions.update.loading === true;

    const {
      editing,

      name,
      email,
      phone,
      job_title,
      password,
      passwordText,
      showPassword,
      passwordInputFocus,
      passwordEdited,
      showSmsOption,
      sendSms,
      invalidPhoneNumber,
      invalidPassword,
    } = this.state;

    return (
      <Form>
        <Card bg="light">
          <Row>
            <Col xs="2">
              <Button
                onClick={() => this.moveKeyholder("Up")}
                disabled={
                  loading ||
                  editing ||
                  updating ||
                  moving ||
                  removing ||
                  position === 1
                }
                style={{ height: "50%", fontSize: "20px", width: "100%" }}
                variant="light">
                <Icon className="fas fa-arrow-circle-up" />
              </Button>
              <Button
                onClick={() => this.moveKeyholder("Down")}
                disabled={
                  loading ||
                  editing ||
                  updating ||
                  moving ||
                  removing ||
                  position === keyholders.length
                }
                style={{ height: "50%", fontSize: "20px", width: "100%" }}
                variant="light">
                <Icon className="fas fa-arrow-circle-down" />
              </Button>
            </Col>
            <Col xs="10" className="pl-0">
              <Card.Body className="pl-0">
                <Form.Group as={Row} className="mb-0">
                  <Col sm="12">
                    <InputGroup className="font-14">
                      <InputGroup.Prepend>
                        <InputGroup.Text
                          style={
                            editing
                              ? {}
                              : {
                                  background: "transparent",
                                  border: "none"
                                }
                          }>
                          <Icon className="fas fa-address-card fa-lg" />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        ref={r => (this.name = r)}
                        className="font-16 font-weight-bold"
                        name="name"
                        plaintext={!editing}
                        readOnly={!editing}
                        value={name}
                        onChange={e => this.setState({ name: e.target.value })}
                      />
                    </InputGroup>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="border-bottom mb-0 font-14">
                  <Form.Label column sm="3">
                    {t("email")}
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      ref={r => (this.email = r)}
                      className="text-right font-14 text-muted"
                      name="email"
                      plaintext={!editing}
                      readOnly={!editing}
                      value={email}
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="border-bottom mb-0 font-14">
                  <Form.Label column sm="3">
                    {t("job_title")}
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      ref={r => (this.job_title = r)}
                      className="text-right text-muted"
                      name="job_title"
                      plaintext={!editing}
                      readOnly={!editing}
                      value={job_title}
                      onChange={e =>
                        this.setState({ job_title: e.target.value })
                      }
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className={`font-14 ${(pathRoot === "sites" || (enterprise && enterprise.single_sites)) ? "border-bottom mb-0" : "mb-3"}`}>
                  <Form.Label column sm="3">
                    {t("phone")}
                  </Form.Label>

                  <Col sm="9">
                    {
                      (pathRoot === "sites" || (enterprise && enterprise.single_sites))
                        ? (
                          editing
                            ? <div>
                                <PhoneInput
                                  ref={r => (this.phone = r)}
                                  className="pl-1"
                                  international
                                  countryCallingCodeEditable={false}
                                  defaultCountry={(site && (site.country || site.country_code)) || "GB"}
                                  name="phone"
                                  plaintext={(!editing).toString()}
                                  readOnly={!editing}
                                  value={phone}
                                  onChange={(value) => {
                                    const phoneNumberValue = (value !== undefined) ? value : "";
                                    const passwordInput = document.getElementById("contact_password");
                                    const passwordValue = passwordInput ? passwordInput.value : "";
                                    this.setState({
                                      phone: phoneNumberValue,
                                      invalidPhoneNumber: "",
                                      showSmsOption: phoneNumberValue !== "" && passwordValue !== "",
                                    })
                                  }}
                                  limitMaxLength={true}
                                  rules={{ validate: isValidPhoneNumber }}
                                />
                                <div style={{ width: "100%" }} className="d-flex justify-content-end text-danger">{invalidPhoneNumber}</div>
                              </div>
                            : <Form.Control
                              className="text-right text-muted"
                              plaintext={true}
                              readOnly={true}
                              value={phone}
                            />
                        )
                        : <Form.Control
                          ref={r => (this.phone = r)}
                          className="text-right text-muted"
                          name="phone"
                          plaintext={!editing}
                          readOnly={!editing}
                          value={phone}
                          onChange={e => this.setState({ phone: e.target.value })}
                        />
                    }
                  </Col>
                </Form.Group>

                {(pathRoot === "sites" || (enterprise && enterprise.single_sites)) &&
                  <Form.Group
                    as={Row}
                    className={
                      `font-14 align-items-center justify-content-between${
                        (pathRoot === "sites" || (enterprise && enterprise.single_sites)) && showSmsOption
                          ? " mb-0"
                          : " mb-3"
                      }`
                    }
                  >
                    <Form.Label column sm="3">
                      {t("password")}
                    </Form.Label>

                    <Col sm="9">
                      {!editing &&
                        <div className="d-flex justify-content-end align-items-center">
                          {password
                            ? <Tooltip
                                description={
                                  sms_sent
                                    ? `SMS: Sent ${getLocalDateMoment(sms_sent, site.timezone).format("DD/MM/YYYY - HH:mm")}`
                                    : phone ? "SMS: Not sent" : "SMS: Not sent - no phone number"
                                }
                                placement="left"
                              >
                                <Form.Control
                                  ref={r => (this.passwordText = r)}
                                  type={password ? "password" : "text"}
                                  className="text-right text-muted"
                                  name="passwordText"
                                  plaintext={true}
                                  readOnly={true}
                                  value={password ? (passwordText || "******" ) : "Not set"}
                                  style={{width: "4rem"}}
                                />
                              </Tooltip>
                            : <Form.Control
                                ref={r => (this.passwordText = r)}
                                type={password ? "password" : "text"}
                                className="text-right text-muted"
                                name="passwordText"
                                plaintext={true}
                                readOnly={true}
                                value={password ? (passwordText || "******" ) : "Not set"}
                                style={{width: "4rem"}}
                              />
                          }
                        </div>
                      }
                      {editing &&
                        <div>
                          <div className="d-flex align-items-center">
                            <div
                              className="form-control d-flex align-items-center"
                              style={{
                                borderRight: "none",
                                borderRadius: "0.25rem 0 0 0.25rem",
                                width: "2.5rem",
                                padding: "0.5rem",
                                fontSize: "1rem",
                                borderColor: passwordInputFocus ? "#2c3e50" : "#ced4da",
                              }}
                              onClick={() => this.setState({ showPassword: !showPassword })}
                            >
                              <Tooltip
                                description={showPassword ? "Hide passcode" : "Show passcode"}
                                placement="top"
                              >
                                <Icon className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                              </Tooltip>
                            </div>
                            <Tooltip
                              description="Enter numbers only, 4-6 digits in length."
                              placement="top"
                            >
                              <Form.Control
                                ref={r => (this.passwordText = r)}
                                type={showPassword ? "text" : "password"}
                                className="text-right text-muted"
                                style={{ borderLeft: "none", borderRadius: "0 0.25rem 0.25rem 0" }}
                                id="contact_password"
                                name="passwordText"
                                value={(showPassword && passwordText === "******" && !passwordEdited) ? "" : passwordText}
                                onChange={e => {
                                  let validatedPasswordText = e.target.value.replace(/\D/g, ""); // remove anything that is not a number
                                  validatedPasswordText = validatedPasswordText.substring(0, 6); // restrict to 6 digits - doing it this way works better for copy/paste than setting maxlength
                                  this.setState({
                                    passwordText: validatedPasswordText,
                                    invalidPassword: "",
                                    passwordEdited: true,
                                    showSmsOption: validatedPasswordText !== "" && phone !== "",
                                  })}
                                }
                                onFocus={() => {
                                  if (!passwordEdited) { //user hasn't made any edits to the password
                                    this.setState({ passwordText: "" }); // show blank password edit box
                                  }
                                  this.setState({ passwordInputFocus: true })
                                }}
                                onBlur={() => {
                                  if (!passwordEdited) { //user hasn't made any edits to the password
                                    this.setState({ passwordText: "******" }); // set the text to the default 6 *s
                                  }
                                  this.setState({ passwordInputFocus: false })}
                                }
                              />
                            </Tooltip>
                            <Tooltip
                              description="Generate a random passcode."
                              placement="top"
                            >
                              <Button
                                onClick={() => {
                                  // generate a 4-digit numerical code
                                  const generatedCode = generateNumericalStringNotAllSame(4);
                                  this.setState({
                                    passwordText: generatedCode,
                                    passwordEdited: true,
                                    showSmsOption: phone !== "",
                                    invalidPassword: "",
                                  });
                                }}
                              >Generate</Button>
                            </Tooltip>
                          </div>
                          <div style={{ width: "100%" }} className="d-flex justify-content-end text-danger">{invalidPassword}</div>
                        </div>
                      }
                    </Col>
                  </Form.Group>
                }

                {(pathRoot === "sites" || (enterprise && enterprise.single_sites)) && showSmsOption &&
                  <Form.Group as={Row} className="pt-1 mb-3 border-top font-14 align-items-center justify-content-between">
                    <Form.Label column sm="3">
                      {t("send_sms")}
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        ref={r => (this.send_sms= r)}
                        type="checkbox"
                        className="text-muted ml-2"
                        style={{ height: "calc(1rem + 4px)", width: "calc(1rem + 4px)" }}
                        name="send_sms"
                        checked={sendSms}
                        onChange={e => this.setState({ sendSms: e.target.checked })}
                      />
                    </Col>
                  </Form.Group>
                }

                <Form.Group as={Row} className="mb-0 font-14">
                  <Col sm="12">
                    {editing ? (
                      <>
                        <Button
                          disabled={loading || updating || removing || moving}
                          onClick={() => {
                            let invalidInputs = false;
                            if (pathRoot === "sites" || (enterprise && enterprise.single_sites)) {
                              if (phone && !isValidPhoneNumber(phone)) {
                                this.setState({ invalidPhoneNumber: "Invalid phone number" });
                                invalidInputs = true;
                              }

                              if (passwordEdited) {
                                if (String(passwordText) !== "") {
                                  const regex = /^[0-9]{4,6}$/;
                                  if (!regex.test(String(passwordText))) {
                                    this.setState({ invalidPassword: "Invalid passcode" });
                                    invalidInputs = true;
                                  }
                                }
                              }
                            }

                            if (!invalidInputs) {
                              this.updateKeyholder();
                            }
                          }}
                          variant="success"
                          className="float-right">
                          {updating && <Loading />} {t("save_button")}
                        </Button>
                        <Button
                          disabled={loading || updating || removing || moving}
                          onClick={() => {
                            this.setState({ editing: false });
                            this.resetFields();
                          }}
                          className="float-right mr-2">
                          {t("cancel_button")}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          disabled={loading || updating || removing || moving}
                          onClick={() => this.setState({
                            passwordText: password ? "******" : "",
                            editing: true,
                          })}
                          className="float-right">
                          <Icon className="fas fa-edit mr-1" />
                          {t("edit_button")}
                        </Button>
                        <Button
                          disabled={loading || updating || removing || moving}
                          variant="danger"
                          onClick={() => {
                            Alert({
                              text: t("confirm_remove", name),
                              icon: "warning",
                              showCancelButton: true
                            }).then(result => {
                              // Confirmed - remove
                              if (result.value) {
                                this.removeKeyholder();
                              }
                            });
                          }}
                          className="float-right mr-2">
                          {removing && <Loading />}{" "}
                          <Icon className="fas fa-times mr-1" />
                          {t("remove_button")}
                        </Button>
                      </>
                    )}
                  </Col>
                </Form.Group>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    actions: state.sites.current.keyholders.actions,
    loading: state.sites.current.keyholders.loading === true,
    enterprise: getEnterpriseFromRoute(state, props),
    pathRoot: getPathRootFromRoute(state),
  };
};
export default connect(mapStateToProps)(
  withT(KeyholderCard, "site_overview.side_pane.keyholders.edit")
);
